import { TabLayout } from "../layouts/TabLayout";
import SimScreen from "../redesign/live/SimScreen";

// 게임 탭 → "모의투자" 허브로 재편 (design doc 2026-06-09-sotda-S-game-tab-to-sim-hub §3).
// 효신님 결정(2026-06-09): 라벨=모의투자(임시) · 차트게임 12종=완전 숨김 · 금융탭 모의투자 카드=제거.
//   - SimScreen을 isTabRoot로 마운트 → 포트폴리오 hero + 종목검색 + 발굴 + 트레이딩 도구 그리드 + 보유/분석.
//   - 차트게임·TOTO·주간 포트폴리오 게임 시스템은 2026-06-14 v1 스코프 좁히기로 .claude/_archive/2026-06-14-game-system/ 은퇴.
export function GamesPage() {
  return (
    <TabLayout page="games">
      <SimScreen isTabRoot />
    </TabLayout>
  );
}
